// extracted by mini-css-extract-plugin
export default {"msgM":"f02aadc663"};